module.exports = __webpack_public_path__ + "img/IMG_1839.d3fae97b.jpg";